import React from 'react';
import '../styles/Blog.css';

const blogPosts = [
  {
    title: 'Benefits of Physiotherapy',
    date: 'April 5, 2025',
    summary: 'Physiotherapy can help improve mobility, reduce pain, and prevent further injuries.'
  },
  {
    title: 'Stretching Exercises for Back Pain',
    date: 'March 28, 2025',
    summary: 'Here are 5 effective stretches to ease chronic lower back pain.'
  },
  {
    title: 'How Posture Affects Your Health',
    date: 'March 15, 2025',
    summary: 'Poor posture can lead to serious health issues. Learn how to correct it today.'
  }
];

const BlogPage = () => {
  return (
    <div className="blog-container">
      <header className="blog-header">
        <h1>Our Blog</h1>
        <p>Stay updated with the latest tips and news in physiotherapy</p>
      </header>

      <div className="blog-list">
        {blogPosts.map((post, index) => (
          <div className="blog-card" key={index}>
            <h2>{post.title}</h2>
            <p className="blog-date">{post.date}</p>
            <p>{post.summary}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogPage;
